import { userSchema } from "../schema/user.schema";

export const USERQUERY = `query ($username: String, $password: String, $id:String, $meta: RequestEntityMetaIn! ) {
     getUser(username: $username, password: $password, id: $id, meta: $meta) {
            count
            users{
                ${userSchema}
            }
            
        }
    }
    `;
